/**
 * Copyright (c) 2021, Ouster, Inc.
 * All rights reserved.
 */
import {
  action,
  thunk,
  Action as EzPzAction,
  Thunk as EzPzThunk,
} from 'easy-peasy';

/// ///////////////////////////////////////////////////////////////////////////
// State Model
/// ///////////////////////////////////////////////////////////////////////////

export type State = {
  toastMessage: string;
  toastShowing: boolean;
  // Keep track of the latest toast launched so the Toast component can
  // be notified of every update. We cannot rely on 'toastShowing' for
  // this because easy-peasy won't trigger useStoreState if the boolean
  // stays true (for instance when the user launches a second toast
  // before the first one disappeared)
  latestToastLaunch?: Date;
};

export const defaultState: State = {
  toastMessage: '',
  toastShowing: false,
};

export interface ToastStateModel extends State {
  launchNewToast: EzPzThunk<ToastStateModel, string>;
  setToastMessage: EzPzAction<ToastStateModel, string>;
  setToastShowing: EzPzAction<ToastStateModel, boolean>;
  setLatestToastLaunch: EzPzAction<ToastStateModel, Date>;
}

export const model: ToastStateModel = {
  ...defaultState,
  launchNewToast: thunk((actions, message) => {
    actions.setToastMessage(message);
    actions.setToastShowing(true);
    actions.setLatestToastLaunch(new Date(Date.now()));
  }),
  setToastMessage: action((state, newToastMessage) => {
    state.toastMessage = newToastMessage;
  }),
  setToastShowing: action((state, newToastShowing) => {
    state.toastShowing = newToastShowing;
  }),
  setLatestToastLaunch: action((state, newTrigger) => {
    state.latestToastLaunch = newTrigger;
  }),
};
